import { render, staticRenderFns } from "./SiftDate.vue?vue&type=template&id=385403e8&scoped=true&"
import script from "./SiftDate.vue?vue&type=script&lang=js&"
export * from "./SiftDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385403e8",
  null
  
)

export default component.exports